/**
 * Gather channel durations (AD-665 / DR-023, `q-gather-channel-completes-on-animation`;
 * docs/systems/gather-channel.md §2). A gather yields only when its channel completes;
 * moving, dodging, attacking or using an ability cancels it (taking damage does not —
 * owner ruling 2026-09-25).
 *
 * DATA, keyed by the node's gathering skill (the node kind the client can see). Each value
 * equals the served player rig's gather clip for that skill, so the motion ends exactly on
 * the yield at its authored speed. Owner ceiling: no single collection over 3.0 s —
 * `GATHER_CHANNEL_MAX_MS`, pinned by test. Mastery does NOT shorten it (a later
 * progression decision would, through this one seam).
 *
 * Shared by the server (the authoritative channel) and the client (the presentation that
 * starts on the press), so both read the same number. Pure; framework-free (AD-122).
 */
import { TICK_MS } from './constants.js';
/** The owner's ceiling on one collection, milliseconds (2026-09-25: "no more than 2-3 seconds"). */
export const GATHER_CHANNEL_MAX_MS = 3000;
/** Channel length per gathering skill, milliseconds. */
export const GATHER_CHANNEL_MS_BY_SKILL = {
    mining: 2200,
    forestry: 1800,
    herbalism: 1900,
    hunting: 1900,
    salvaging: 1900,
};
/** A skill the table does not name channels for this long (the longest row — never longer than the cap). */
export const DEFAULT_GATHER_CHANNEL_MS = 2200;
/** The channel for a gathering skill, milliseconds, clamped to [one tick, the owner's ceiling]. */
export function gatherChannelMs(skill) {
    const own = skill != null && Object.prototype.hasOwnProperty.call(GATHER_CHANNEL_MS_BY_SKILL, skill)
        ? GATHER_CHANNEL_MS_BY_SKILL[skill]
        : undefined;
    const ms = typeof own === 'number' && Number.isFinite(own) ? own : DEFAULT_GATHER_CHANNEL_MS;
    return Math.min(GATHER_CHANNEL_MAX_MS, Math.max(TICK_MS, ms));
}
/** The channel in whole server ticks (rounded up: the yield never lands before the clip ends). */
export function gatherChannelTicks(skill) {
    return Math.max(1, Math.ceil(gatherChannelMs(skill) / TICK_MS - 1e-9));
}
//# sourceMappingURL=gatherChannel.js.map